/*
Author : Abaid ullah
Module: INVITATION
github: https://github.com/abaid
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import axios from 'axios';
import {URL} from "../../Apis/Constants";
import {errorMsg} from "../../Apis/functions";
import apiInstance from "../../Apis/Axios";

import {ADVANCED_SEARCH_SERVICE, EVENT_SERVICE, INVITATION_SERVICE, USER_SERVICE} from '../EndPoints';
const config = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
    },
};
const PUBLIC = 'public/'

// List all the invitation
export const GetAllInvitation = createAsyncThunk(
    'invitation/getAllInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(ADVANCED_SEARCH_SERVICE.getAllInvitation, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetSearchUserService = createAsyncThunk(
    'invitation/getSearchUserService',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${params.type === 'email' ? INVITATION_SERVICE.getSearchUserServiceByEmail : INVITATION_SERVICE.getSearchUserServiceByPhone}/${params.value}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
// create invitation
export const CreateInvitation = createAsyncThunk(
    'invitation/createInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(INVITATION_SERVICE.createInvitation, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// submit invitation
export const SubmitInvitation = createAsyncThunk(
    'invitation/submitInvitation',
    async (formData, { dispatch, getState }) => {
        const result = await axios
            .put(`${URL}${INVITATION_SERVICE.submitInvitation}${formData.id}`, formData.aux)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete invitation
export const DeleteInvitation = createAsyncThunk(
    'invitation/deleteInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(`${INVITATION_SERVICE.deleteInvitation}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetInvitationById = createAsyncThunk(
    'invitation/getInvitationById',
    async (params) => {
        try {
            return await axios.get(`${URL}${INVITATION_SERVICE.getInvitationById}${params}`, config);
        } catch (error) {
            if (!error.response) {
               errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const CancelInvitation = createAsyncThunk(
    'invitation/cancelInvitation',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(EVENT_SERVICE.cancelInvitation, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const CountAllByAllStatus = createAsyncThunk(
    'invitation/countAllByAllStatus',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${INVITATION_SERVICE.countAllByAllStatus}${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdateVisitorStatusByInvitationId = createAsyncThunk(
    'invitation/updateVisitorStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
           .put(
                INVITATION_SERVICE.updateVisitorStatusByInvitationId(
                    params?.invitationId,
                    params?.statusId
                )
            )
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetInvitationHeadersByOption = createAsyncThunk(
    'invitation/getInvitationHeadersByOption',
    async (option, { dispatch, getState }) => {
        try {
            const response = await apiInstanceV2.get(`${INVITATION_SERVICE.getInvitationHeadersByOption}${option}`);
            const { data, status } = response;
            return { data, status };
        } catch (error) {
            const { response } = error;
            return { data: response.data, status: response.status };
        }
    },
);

export const GetInvitationValuesByOptionFieldAndUserId = createAsyncThunk(
    'invitation/getInvitationValuesByOptionFieldAndUserId',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(INVITATION_SERVICE.getInvitationValuesByOptionFieldAndUserId(params.field, params.userId, params.viewType))
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateStatusByInvitationId = createAsyncThunk(
    'invitation/updateStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(
                INVITATION_SERVICE.updateStatusByInvitationId(
                    params?.invitationId,
                    params?.option,
                    params?.statusReason
                )
            )
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const publicUpdateStatusByInvitationId = createAsyncThunk(
    'invitation/publicUpdateStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.put(`${URL}${INVITATION_SERVICE.publicUpdateStatusByInvitationId(
                    params?.invitationId,
                    params?.option,
                    params?.statusReason
                )}`
            );
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const PublicCreateUserFile = createAsyncThunk('invitation/publicCreateUserFile', async (params, { dispatch, getState }) => {
        try {
            return await axios.post(`${URL}${USER_SERVICE.publicCreateUserFile}`, params);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const PublicDeleteUserFile = createAsyncThunk('invitation/publicDeleteUserFile', async (params, { dispatch, getState }) => {
        try {
            return await axios.delete(`${URL}${USER_SERVICE.publicDeleteUserFile}${params}`);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const PublicDeleteUserImageByUserAndAccessMethod = createAsyncThunk('invitation/PublicDeleteUserImageByUserAndAccessMethod',
    async ({userId, accessMethodId}, { dispatch, getState }) => {
        try {
            return await axios.delete(`${URL}${USER_SERVICE.publicDeleteUserImageByUserAndAccessMethod}${userId}/${accessMethodId}`);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const publicUpdateVisitorStatusByInvitationId = createAsyncThunk(
    'invitation/publicUpdateVisitorStatusByInvitationId',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.put(`${URL}${INVITATION_SERVICE.publicUpdateVisitorStatusByInvitationId(
                    params?.invitationId,
                    params?.statusId
                )}`);
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const publicGenerateICSByInvitation = createAsyncThunk(
    'invitation/publicGenerateICSByInvitation',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.put(`${URL}${INVITATION_SERVICE.publicGenerateICSByInvitation(
                    params?.invitationId,
                    params?.action
                )}`,null,
                { responseType: 'blob' }
            );
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const publicDeleteItemsById = createAsyncThunk(
    'invitation/publicDeleteItemsById',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.post(
                `${URL}${INVITATION_SERVICE.publicDeleteItemsById}`, params, { headers: { 'Content-Type': 'application/json' } }
            );
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status);
            }
            return { data: error.response?.data, status: error.response?.status };
        }
    }
);

export const PublicGetQrCodeByUserId = createAsyncThunk(
    'invitation/publicGetQrCodeByUserId',
    async (params) => {
        try {
            return await axios.get(`${URL}user-service/${PUBLIC}qr-code/${params?.userId}/${params?.invitationId}`)
        } catch (error) {
            if (!error.response) {
                errorMsg(error.response.status)
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const NotifyHost = createAsyncThunk(
    'invitation/notifyHost',
    async (id, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${INVITATION_SERVICE.notifyHost}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const InvitationMarkFilesAsRead = createAsyncThunk('invitation/markFilesAsRead', async (body) => {
    const response = await apiInstance
        .post(INVITATION_SERVICE.markFilesAsRead, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


